import React from 'react';
import { Link } from 'react-router-dom'
import AddNewIocn from "../../assets/images/new.png";
import './card-style.css'
import Button from "react-bootstrap/Button";


function CreateEvent(props) {
    let { id, category, count } = props.eventcategory;


    function createEvents() {
        ////console.log("Calling Create Events")
        props.onclick()
    }
    return (
        <div className='card text-center shadow newCard-add' key="123">
            <div className='overflow' key="124">
                <Button color="fffff" onClick={() => { createEvents() }}>
                    <img src={AddNewIocn} />
                </Button>
                <div className='card-body text-dark' key="125">
                    <h4 className='card-text'>{category}</h4>
                </div>
            </div>
        </div>
    );
}






export default CreateEvent;
